// src/utils/encryption.js
import CryptoJS from 'crypto-js';

// Generate a key from passphrase using PBKDF2
export const generateKey = (passphrase) => {
  return CryptoJS.PBKDF2(passphrase, 'hot-setup-salt', {
    keySize: 256 / 32,
    iterations: 10000
  });
};

// Encrypt data
export const encryptData = (data, passphrase) => {
  const key = generateKey(passphrase);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key.toString()).toString();
  return encrypted;
};

// Decrypt data
export const decryptData = (encryptedData, passphrase) => {
  try {
    const key = generateKey(passphrase);
    const bytes = CryptoJS.AES.decrypt(encryptedData, key.toString());
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    throw new Error('Invalid passphrase or corrupted data');
  }
};

// Store passphrase in localStorage (not secure, but as requested)
export const storePassphrase = (passphrase) => {
  localStorage.setItem('hotsetup-encryption-passphrase', passphrase);
};

// Get stored passphrase
export const getStoredPassphrase = () => {
  return localStorage.getItem('hotsetup-encryption-passphrase');
};

// Clear stored passphrase
export const clearStoredPassphrase = () => {
  localStorage.removeItem('hotsetup-encryption-passphrase');
};

// Check if encryption is enabled for user
export const isEncryptionEnabled = async (user, db) => {
  const { doc, getDoc } = await import('firebase/firestore');
  const userDocRef = doc(db, `users/${user.uid}`);
  const userDoc = await getDoc(userDocRef);
  return userDoc.exists() && userDoc.data().encryptionEnabled === true;
};

// Enable encryption for user
export const enableEncryption = async (user, db) => {
  const { doc, updateDoc, setDoc } = await import('firebase/firestore');
  const userDocRef = doc(db, `users/${user.uid}`);
  try {
    await updateDoc(userDocRef, { encryptionEnabled: true });
  } catch (error) {
    // If doc doesn't exist, create it
    await setDoc(userDocRef, { encryptionEnabled: true });
  }
};

// Disable encryption for user
export const disableEncryption = async (user, db) => {
  const { doc, updateDoc } = await import('firebase/firestore');
  const userDocRef = doc(db, `users/${user.uid}`);
  await updateDoc(userDocRef, { encryptionEnabled: false });
  // Clear stored passphrase
  clearStoredPassphrase();
};